import CropAndSaveImageRequest from "@/api/dataSource/api/Spirit/Common/FileManager/Models/CropAndSaveImageRequest";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";

export function mapToCropRequest(img: ImagePreviewModel): CropAndSaveImageRequest {
    if (!img.Width && !img.Height) {
        return null;
    }
    return new CropAndSaveImageRequest({
        ImgBase: img.ImageUrl,
        Height: parseInt(img.Height.toString()),
        Left: parseInt(img.Left.toString()),
        Top: parseInt(img.Top.toString()),
        Width: parseInt(img.Width.toString())
    });
}